// extracted by mini-css-extract-plugin
export var autoExpand = "_2y-8";
export var container = "_2y-7";
export var containerWidth = "_2y-5";
export var disabled = "_2y-2";
export var error = "_2y-3";
export var fullWidth = "_2y-6";
export var inputWrapper = "_2y-0";
export var small = "_2y-1";
export var textarea = "_2y-4";